import { render, staticRenderFns } from "./vip-equipment-detail.vue?vue&type=template&id=b4963890&scoped=true"
import script from "./vip-equipment-detail.vue?vue&type=script&lang=js"
export * from "./vip-equipment-detail.vue?vue&type=script&lang=js"
import style0 from "./vip-equipment-detail.vue?vue&type=style&index=0&id=b4963890&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4963890",
  null
  
)

export default component.exports